import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ContactMessage, Mail, Response} from '../models/models';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MailService {

  constructor(private httpClient: HttpClient) { }

  sendMail(mail: ContactMessage): Observable<Response<boolean>> {
    return this.httpClient.post<Response<boolean>>(environment.apiPath + 'MailService/SendMail', { mail });
  }

  getMailServices(): Observable<Response<Mail[]>> {
    return this.httpClient.get<Response<Mail[]>>(environment.apiPath + 'MailService');
  }

  insertMailService(mail: Mail): Observable<Response<Mail>> {
    return this.httpClient.post<Response<Mail>>(environment.apiPath + 'MailService/', mail);
  }

  updateMailService(id: number, mail: Mail): Observable<Response<Mail>> {
    return this.httpClient.put<Response<Mail>>(environment.apiPath + 'MailService/' + id, mail);
  }

  deleteMailService(id: number) {
    return this.httpClient.delete<Response<boolean>>(environment.apiPath + 'MailService/' + id);
  }
}
